/**
 * @generated SignedSource<<36b7a6a929fb4c967cf91b370f95a81f>>
 * @relayHash 223430fcef0199174408eef3caf31cba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e1a1638c395c7d19d918fe04631fd5b4ea0f7132ab6e4a35e0ea4feba0b2a156

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { addPaymentMethodButtonTrialModalQuery } from './addPaymentMethodButtonTrialModalQuery.graphql';

const node: PreloadableConcreteRequest<addPaymentMethodButtonTrialModalQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "e1a1638c395c7d19d918fe04631fd5b4ea0f7132ab6e4a35e0ea4feba0b2a156",
    "metadata": {},
    "name": "addPaymentMethodButtonTrialModalQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
